import React from 'react';
import Layout from '../../components/Layout';
import Pricing from './Pricing';
import { getCategory } from '../../actions/category/getCategory';

const title = 'BestHand Pricing — Upfront, Transparent Rates';
// Description copy intentionally avoids hardcoded fee numbers; the live figures are shown on the page
// itself from the DB (Category.travellingPrice / userServiceFeeValue).
const description =
  'BestHand pricing is simple and upfront: your pro’s rate plus a transparent service fee and a per-booking visit fee — always shown before you book. Industry-low fees, no hidden charges.';

async function action({ store }) {
  // Ensure the public categories (with per-category fees) are loaded so the page can render the
  // real DB fee values. Mirrors the /category route loader.
  const categories = store.getState().categories?.data;
  !categories && (await store.dispatch(getCategory()));

  return {
    title,
    description,
    component: (
      <Layout>
        <Pricing />
      </Layout>
    ),
  };
}

export default action;
